/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellFill: {
  name: 'bell-fill';
  data: string;
} = {
  name: 'bell-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 9a7 7 0 0 1 14 0v4.697l.796 1.194C20.682 16.22 19.729 18 18.132 18H16a4 4 0 0 1-8 0H5.87c-1.598 0-2.55-1.78-1.664-3.11L5 13.698V9Zm5 9a2 2 0 1 0 4 0h-4Z" fill="currentColor"/></svg>`,
};
